/**
 * FEX-1192 — Catálogo de stickers del Chat interno (SipMóvil).
 *
 * No hay tipo "sticker" en el backend: el sticker se envía como una imagen más
 * por POST /attached. Lo que lo distingue de una imagen normal es el PREFIJO de
 * su nombre de archivo, que sobrevive el renombrado con hash de
 * ConversationService.uploadSipmovilFiles (fexsticker_01.png → fexsticker_01_a1b2c3.png)
 * y viaja dentro de message.file_message. Por eso el render sin burbuja funciona
 * igual para el emisor, el receptor, el historial y después de un F5.
 *
 * Este archivo es la ÚNICA fuente de verdad del prefijo: lo usan el picker
 * (para armar el File que se sube), ConversationMessage/FloatingMessage (para
 * detectar el sticker al pintar) y chatAttachments (para ocultarlos del panel
 * de archivos).
 *
 * Para agregar stickers: subir el PNG a public/static/stickers/ respetando el
 * prefijo y ampliar STICKERS_COUNT (o listar el nombre a mano si rompe la
 * numeración correlativa).
 */

export const STICKER_PREFIX = 'fexsticker_';
export const STICKERS_BASE = '/static/stickers/';
const STICKERS_COUNT = 19;

export const stickers = Array.from({ length: STICKERS_COUNT }, (_, i) => {
  const id = String(i + 1).padStart(2, '0');
  const name = `${STICKER_PREFIX}${id}.png`;
  return {
    id,
    name,
    url: `${STICKERS_BASE}${name}`,
  };
});

/**
 * ¿El archivo es un sticker? Acepta tanto un nombre suelto como una URL o ruta
 * completa (se queda con el último segmento antes de comparar).
 */
export function isStickerFileName(filePath) {
  if (!filePath || typeof filePath !== 'string') return false;
  const clean = filePath.split('?')[0];
  const baseName = clean.substr(clean.lastIndexOf('/') + 1);
  return baseName.toLowerCase().startsWith(STICKER_PREFIX.toLowerCase());
}

/**
 * Descarga el PNG del sticker y lo convierte en File para reutilizar el
 * pipeline de adjuntos (APPEND_FILE + uploadSipmovilFiles). Mismo origen, así
 * que no hay CORS de por medio ni en dev ni en producción.
 */
export async function buildStickerFile(sticker) {
  const response = await fetch(sticker.url);
  if (!response.ok) throw new Error(`No se pudo cargar el sticker ${sticker.name}`);
  const blob = await response.blob();
  return new File([blob], sticker.name, { type: blob.type || 'image/png' });
}

export default stickers;
